import { createStore } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import { getLocalUser } from '../helpers/auth'
import { getCurrentContract, getCurrentComponent, getAllContracts } from '../helpers/localStorage'

const user = getLocalUser()
const contract = getCurrentContract()
const contracts = getAllContracts()
const component = getCurrentComponent()
const store = createStore({
	state: {
		currentUser: user,
		currentContract: contract,
		allContracts: contracts,
		currentComponent: component,
		activeTab: 0,
		hideConfigButton: false,
		isPinned: true,
		showConfig: false,
		isRTL: false,
		color: "",
		sidebarType: "bg-white",
		darkMode: false,
		isNavFixed: false,
		isAbsolute: false,
		showNavs: true,
		showSidenav: true,
		showNavbar: true,
		showFooter: true,
		showMain: true,
		layout: "default",
		bootstrap,
	},
	getters: {
		getCurrentUser(state) {
			return state.currentUser;
		},
		getCurrentComponent(state) {
			return state.currentComponent;
		},
		getCurrentContract(state) {
			return state.currentContract;
		},
		getAllContract(state) {
			return state.allContracts;
		},

	},
	mutations: {
		updateContract(state, newValue) {
			state.currentContract = newValue;
			localStorage.setItem("currentContract", JSON.stringify(state.currentContract))
		},
		updateAllContracts(state, newValue) {
			state.allContracts = newValue;
			localStorage.setItem("allContracts", JSON.stringify(state.allContracts))
		},
		updateComponent(state, newValue) {
			state.currentComponent = newValue;
			localStorage.setItem("currentComponent", state.currentComponent)
		},
		toggleConfigurator(state) {
			state.showConfig = !state.showConfig;
		},
		navbarMinimize(state) {
			const sidenav_show = document.querySelector(".g-sidenav-show");
			if (sidenav_show.classList.contains("g-sidenav-hidden")) {
				sidenav_show.classList.remove("g-sidenav-hidden");
				sidenav_show.classList.add("g-sidenav-pinned");
				state.isPinned = true;
			} else if (sidenav_show.classList.contains("g-sidenav-pinned")) {
				sidenav_show.classList.add("g-sidenav-hidden");
				sidenav_show.classList.remove("g-sidenav-pinned");
				state.isPinned = false;
			} else if (window.innerWidth < 1200) {
				sidenav_show.classList.add("g-sidenav-pinned");
				state.isPinned = true;
			} else {
				sidenav_show.classList.add("g-sidenav-hidden");
			}
		},
		setSidebarType(state, payload) {
			state.sidebarType = payload;
		},
		navbarFixed(state) {
			state.isNavFixed = !state.isNavFixed;
		},
		toggleDefaultLayout(state) {
			state.showNavbar = !state.showNavbar;
			state.showSidenav = !state.showSidenav;
			state.showFooter = !state.showFooter;
		},
		logout(state) {
			location.reload()
			localStorage.removeItem("user")
			localStorage.removeItem("currentContract")
			localStorage.removeItem("allContracts")
			localStorage.removeItem("currentComponent")
			state.currentUser = null
			state.currentContract = null
			state.allContracts = null
			state.currentComponent = null
		},
		loginSuccess(state, payload) {
			state.currentUser = Object.assign({}, payload.user, { token: payload.access_token })
			localStorage.setItem("user", JSON.stringify(state.currentUser))
			localStorage.setItem("currentComponent", "PrincipalCard")
		},
	},
	actions: {
		toggleSidebarColor({ commit }, payload) {
			commit("setSidebarType", payload);
		},
	},
});

export default store;